import { useGetDictionaryByType } from 'api/generated/dictionary-controller/dictionary-controller';

export type DictionaryByTypeName = Parameters<typeof useGetDictionaryByType>[1];

interface UseDictionaryByTypeOptions {
  enabled?: boolean;
}

export const useDictionaryByType = (
  userId: string,
  type: DictionaryByTypeName,
  options?: UseDictionaryByTypeOptions
) => {
  const enabled = options?.enabled ?? true;

  return useGetDictionaryByType(userId, type, {
    query: { enabled: enabled && !!userId },
  });
};
